import { createI18n } from 'vue-i18n';
import { en as vuetifyEn, de as vuetifyDe } from 'vuetify/locale';
import { DEFAULT_LOCALE } from '@KTXC/l10n/config';

/**
 * The single vue-i18n instance shared by the core shell and all modules.
 */
export const i18n = createI18n({
  legacy: false,
  globalInjection: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: false,
  messages: {
    // Vuetify component strings ($vuetify.*) ride along in the same
    // instance, consumed through the createVueI18nAdapter in the vuetify
    // plugin. Statically imported: adding a locale means adding it here.
    en: { $vuetify: vuetifyEn },
    de: { $vuetify: vuetifyDe },
  },
});

/** Merge a catalog's messages under a namespace for the given locale. */
export function mergeCatalog(locale: string, namespace: string, messages: Record<string, unknown>): void {
  i18n.global.mergeLocaleMessage(locale, { [namespace]: messages });
}

/** Switch the active locale of the shared instance. */
export function applyLocale(locale: string): void {
  i18n.global.locale.value = locale;
}

/** Update the locale used when a translation is missing from the active locale. */
export function applyFallbackLocale(locale: string): void {
  i18n.global.fallbackLocale.value = locale;
}
